import { render, staticRenderFns } from "./VBulkEditDialog.vue?vue&type=template&id=2e88bb30&"
import script from "./VBulkEditDialog.vue?vue&type=script&lang=js&"
export * from "./VBulkEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports